import { render, staticRenderFns } from "./adminSupportSidebar.vue?vue&type=template&id=e3d01f90&scoped=true&"
import script from "./adminSupportSidebar.vue?vue&type=script&lang=js&"
export * from "./adminSupportSidebar.vue?vue&type=script&lang=js&"
import style0 from "./adminSupportSidebar.vue?vue&type=style&index=0&id=e3d01f90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3d01f90",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VExpandXTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VExpandXTransition,VIcon,VImg,VProgressLinear,VSheet})
